import { render, staticRenderFns } from "./employeeTagsColumn.vue?vue&type=template&id=56673de8"
import script from "./employeeTagsColumn.vue?vue&type=script&lang=js"
export * from "./employeeTagsColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports